import React, { useEffect, useState } from "react"
import { StreamChat as StreamChatClient } from "stream-chat"
import {
  Chat,
  Channel,
  ChannelHeader,
  MessageList,
  MessageInput,
  Thread,
  Window,
} from "stream-chat-react"

const ChatWidget = ({ channelId, channelType = "messaging", userId, userName, apiKey, token }) => {
  const [client, setClient] = useState(null)
  const [channel, setChannel] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (document.documentElement.dataset.railsEnv === "test") return
    if (!apiKey || !token || !userId) {
      setError("Missing required configuration: apiKey, token, or userId")
      return
    }

    let chatClient = null
    let isActive = true

    const initChat = async () => {
      try {
        chatClient = StreamChatClient.getInstance(apiKey)
        await chatClient.connectUser({ id: userId, name: userName || userId }, token)

        if (!isActive) { await chatClient.disconnectUser(); return }

        const chatChannel = chatClient.channel(channelType, channelId || "general", {
          name: channelId ? `Channel ${channelId}` : "General",
        })
        await chatChannel.watch()

        if (!isActive) { await chatClient.disconnectUser(); return }

        setClient(chatClient)
        setChannel(chatChannel)
      } catch (err) {
        console.error("ChatWidget: Failed to initialize:", err)
        if (isActive) setError(`Failed to connect: ${err.message}`)
      }
    }

    initChat()
    return () => {
      isActive = false
      if (chatClient) chatClient.disconnectUser().catch(() => {})
    }
  }, [apiKey, token, userId, userName, channelId, channelType])

  if (error) {
    return (
      <div className="cf-chat-error">
        <div className="cf-chat-error__icon">!</div>
        <h3>Chat Connection Error</h3>
        <p>{error}</p>
      </div>
    )
  }

  if (!client || !channel) {
    return (
      <div className="cf-chat-loading">
        <div className="cf-chat-loading__spinner" />
        <p>Connecting to chat...</p>
      </div>
    )
  }

  return (
    <div className="cf-chat-widget">
      <Chat client={client} theme="str-chat__theme-dark">
        <Channel channel={channel}>
          <Window>
            <ChannelHeader />
            <MessageList />
            <MessageInput />
          </Window>
          <Thread />
        </Channel>
      </Chat>
    </div>
  )
}

export default ChatWidget
